import { BehaviorSubject } from 'rxjs';
import jwt_decode from "jwt-decode";
import { spinnerService } from './spinner.service';
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';

const currentUserTokenSubject = new BehaviorSubject({});


export const authenticationService = {

    login,
    Logout,
    currentUserObject,
    isLoggedIn,
    getToken,
    currentUserSubject: currentUserTokenSubject.asObservable(),
    get currentUserTokenValue () { return  localStorage.getItem('token') }
};

function Logout() {
    // remove user from local storage to log user out
    
    localStorage.removeItem('token');
    currentUserTokenSubject.next(null);
   
}


    function isLoggedIn() {
        const TOKEN =  getToken();
        if(TOKEN){
            const payLoad = jwt_decode(TOKEN);
            if (payLoad.exp){
                if(payLoad.exp > Date.now() / 1000) {
                    return true;
                } else{
                    return false;
                } 
            }else{
                return false;
                
            }
        }
        return false
        }

function currentUserObject(){
    const TOKEN =  getToken();
    if(TOKEN){
        const payLoad = jwt_decode(TOKEN);
        const User_Id = payLoad['User_Id'];
        const Authentication_Token = payLoad['Authentication_Token'];
        const email = payLoad['email'];
        const  userprops = {User_Id, Authentication_Token, email}
        currentUserTokenSubject.next(userprops);
        return userprops;

    }else{
        console.info('No token')
        return {}
    }
  
}


function getToken(){
    return localStorage.getItem('token');
}



  async function  login(body) {
    return  apiClient.post(`/login`, body, authHeader());
}
  


